import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const BLUE = '#2563eb';
const WHITE = '#ffffff';
const TEXT = '#0a0a0a';
const TEXT_MUTED = '#666666';
const BORDER = '#e2e8f0';

const LINKS = [
  { to: '/guide', label: 'Guide', key: 'guide' },
  { to: '/about', label: 'About', key: 'about' },
  { to: '/stats', label: 'Stats', key: 'stats' },
];

function linkStyle(isActive) {
  return { fontSize: 14, fontWeight: isActive ? 700 : 600, color: isActive ? BLUE : TEXT_MUTED, textDecoration: 'none' };
}

function HoverBtn({ to, children }) {
  const [hover, setHover] = useState(false);
  return (
    <Link
      to={to}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: hover ? '#f0f9ff' : WHITE,
        color: BLUE,
        border: '1.5px solid ' + BLUE,
        borderRadius: 10,
        padding: '9px 20px',
        fontSize: 13,
        fontWeight: 700,
        textDecoration: 'none',
        display: 'inline-flex',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease',
        transform: hover ? 'translateY(-2px)' : 'translateY(0)',
        boxShadow: hover ? '0 8px 20px rgba(37,99,235,0.15)' : 'none',
      }}
    >
      {children}
    </Link>
  );
}

export default function PublicNav({ isMobile, active }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const px = isMobile ? 16 : 60;

  return (
    <>
      <div style={{ background: WHITE, borderBottom: '1px solid ' + BORDER, padding: `0 ${px}px`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 56, position: 'sticky', top: 0, zIndex: 100 }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
          <div style={{ width: 28, height: 28, background: BLUE, borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={WHITE} strokeWidth="2.5" strokeLinecap="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></svg>
          </div>
          <span style={{ fontSize: 17, fontWeight: 800, color: TEXT, letterSpacing: '-0.3px' }}>Pre<span style={{ color: BLUE }}>Visr</span></span>
        </Link>

        {!isMobile && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 28 }}>
            {LINKS.map(function (l) {
              return <Link key={l.key} to={l.to} style={linkStyle(active === l.key)}>{l.label}</Link>;
            })}
            <HoverBtn to="/login">Login / signup</HoverBtn>
          </div>
        )}

        {isMobile && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <HoverBtn to="/login">Login / signup</HoverBtn>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
              style={{ background: WHITE, border: '1px solid ' + BORDER, borderRadius: 8, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={TEXT} strokeWidth="2" strokeLinecap="round">
                {menuOpen ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 6h16M4 12h16M4 18h16" />}
              </svg>
            </button>
          </div>
        )}
      </div>

      {isMobile && menuOpen && (
        <div style={{ background: WHITE, borderBottom: '1px solid ' + BORDER, padding: `16px ${px}px 20px`, display: 'flex', flexDirection: 'column', gap: 16, position: 'sticky', top: 56, zIndex: 99 }}>
          <Link to="/" onClick={() => setMenuOpen(false)} style={linkStyle(false)}>Home</Link>
          {LINKS.map(function (l) {
            return <Link key={l.key} to={l.to} onClick={() => setMenuOpen(false)} style={linkStyle(active === l.key)}>{l.label}</Link>;
          })}
        </div>
      )}
    </>
  );
}
